






































import Vue from 'vue';
import { HeroImage } from '@/components/ds';
import { getAssetPath } from '@/helpers/assets';
import i18n from '@/i18n';

export default Vue.extend({
  components: {
    HeroImage,
  },
  props: {
    enemAverage: {
      type: Number,
      required: true,
    },
    success: {
      type: Boolean,
      required: true,
    },
    userFirstName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      backgroundSrc: getAssetPath('img/BackgroundImage.svg'),
      maskUrl: getAssetPath('img/mask.svg'),
    };
  },
  computed: {
    average(): string {
      return this.enemAverage.toFixed(2);
    },
    iconSrc(): string {
      return this.success ? getAssetPath('img/freshmanLife.svg') : getAssetPath('img/vish.svg');
    },
    imgSrc(): string {
      return this.success
        ? getAssetPath('img/hero/success.jpg')
        : getAssetPath('img/hero/retry.jpg');
    },
    hasBackground(): boolean {
      return this.success;
    },
    subtitle(): string {
      const i18nKey = this.success ? 'result.enem.successSubtitle' : 'result.enem.retrySubtitle';

      return i18n.t(i18nKey);
    },
    title(): string {
      const i18nKey = this.success ? 'result.enem.successTitle' : 'result.enem.retryTitle';

      return i18n.t(i18nKey, { name: this.userFirstName });
    },
  },
});
